import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const SidePanelIcon = createIcon({
  displayName: 'SidePanelIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 4h15A1.5 1.5 0 0 1 21 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18.5v-13A1.5 1.5 0 0 1 4.5 4Zm5.5 2v12h9V6h-9Z'
    />
  ),
});
